module.exports = __webpack_public_path__ + "images/category_lp/hobby/store_images/3@2x_f3be060af0dae4f0cb4a0b0621925d13.png";